<template>
  <div class="py-4 container-fluid">
    <!-- RINGKASAN -->
    <div class="row">
      <div class="col-lg-3 col-md-6 mb-3" v-for="(card, i) in cards" :key="'c'+i">
        <div class="card" style="cursor: pointer;" @click="filterStatus(card.filter)">
          <div class="card-body p-3">
            <p class="text-sm mb-1 text-uppercase font-weight-bold">{{ card.label }}</p>
            <h5 :class="'font-weight-bolder mb-0 '+card.color">{{ card.value }}</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-warning text-white text-sm" v-if="missingRates.length > 0">
      <i class="fa fa-exclamation-triangle"></i> Kurs <b>{{ missingRates.join(', ') }}</b> belum diisi, PO dalam mata uang ini dihitung 0 di realisasi.
      <a href="javascript:void(0)" class="text-white font-weight-bold" @click="openRates()"><u>Isi kurs sekarang</u></a>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-lg-4">
              <div class="card-header pb-0">
                <h6>Budget Control (Anggaran vs Realisasi)</h6>
                <p class="text-xs mb-0">Realisasi = nilai PO terbit, excl. PPN, dalam IDR. Warning saat mencapai batas % yang diatur, email saat melewati 100%.</p>
              </div>
            </div>
            <div class="col-lg-3">
              <input type="text" class="form-control mt-3" placeholder="Cari WO / Proyek / Client" v-model="search.search" v-on:keyup.enter="get()">
            </div>
            <div class="col-lg-2">
              <select class="form-select mt-3" v-model="search.status" @change="get()">
                <option value="">Semua Status</option>
                <option value="ok">Aman</option>
                <option value="warning">Warning</option>
                <option value="over">Over Budget</option>
                <option value="no_budget">Belum Ada Anggaran</option>
              </select>
            </div>
            <div class="col-lg-3">
              <argon-button class="mt-4" variant="gradient" color="info" size="sm" @click="openRates()"><i class="fa fa-exchange fa-sm" aria-hidden="true"></i> Kurs Mata Uang</argon-button>
            </div>
          </div>

          <div class="card-body px-0 pt-0 pb-2 mt-4">
            <div class="table-responsive p-0 scroll">
              <table class="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">WO</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Proyek</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Anggaran</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Realisasi PO</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder" style="min-width: 160px;">Pemakaian</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Diterima</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Dibayar</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder">Status</th>
                    <th class="text-secondary"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in table.data" :key="i">
                    <td class="align-middle text-center"><span class="badge badge-sm bg-gradient-primary">{{ row.wo_code }}</span></td>
                    <td class="align-middle">
                      <span class="text-secondary text-xs font-weight-bold">{{ row.project }}</span><br>
                      <span class="text-secondary text-xxs">{{ row.client }}</span>
                    </td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ row.total_budget !== null ? fmt(row.total_budget) : '-' }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.committed) }}</span></td>
                    <td class="align-middle">
                      <div v-if="row.percent !== null">
                        <span class="text-xs font-weight-bold">{{ row.percent }}%</span>
                        <div class="progress">
                          <div :class="'progress-bar '+barColor(row.percent, row.level)" role="progressbar" :style="'width: '+Math.min(100, row.percent)+'%'"></div>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.received) }}</span></td>
                    <td class="align-middle text-end"><span class="text-secondary text-xs font-weight-bold">{{ fmt(row.paid) }}</span></td>
                    <td class="align-middle text-center">
                      <span class="badge badge-sm bg-gradient-danger" v-if="row.level == 'over'">Over Budget</span>
                      <span class="badge badge-sm bg-gradient-warning" v-else-if="row.level == 'warning'">Warning</span>
                      <span class="badge badge-sm bg-gradient-success" v-else-if="row.level == 'ok'">Aman</span>
                      <span class="badge badge-sm bg-gradient-secondary" v-else>Belum Ada Anggaran</span>
                      <br v-if="row.line_alerts > 0"><span class="text-xxs text-danger" v-if="row.line_alerts > 0">{{ row.line_alerts }} rincian perlu perhatian</span>
                    </td>
                    <td>
                      <i class="fa fa-eye fa-sm" aria-hidden="true" title="Lihat anggaran vs realisasi per kategori, supplier, dan item" style="cursor: pointer; margin-right: 15px;" @click="openDetail(row.wo_code)"></i>
                      <i class="fas fa-edit fa-sm" aria-hidden="true" :title="row.budget_id ? 'Ubah anggaran' : 'Buat anggaran'" style="cursor: pointer; margin-right: 15px;" @click="openForm(row.wo_code)"></i>
                      <i class="fa fa-trash fa-sm" aria-hidden="true" title="Hapus anggaran" style="cursor: pointer;" @click="removeBudget(row)" v-if="row.budget_id"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="float-left">TOTAL ROWS : {{ table.data.length }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- =======  MODAL DETAIL ======= -->
  <div class="container">
    <vue-final-modal v-model="formDetail.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{ detail.wo ? detail.wo.wo_code+' - '+detail.wo.project : '' }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formDetail.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <div class="row text-sm mb-3">
          <div class="col-md-3">Anggaran<br><b>{{ detail.budget ? fmt(detail.budget.total_budget) : 'Belum ada' }}</b></div>
          <div class="col-md-3">Realisasi PO<br><b>{{ fmt(detail.total.committed) }}</b> <span v-if="detail.evaluation">({{ detail.evaluation.header.percent }}%)</span></div>
          <div class="col-md-3">Diterima<br><b>{{ fmt(detail.total.received) }}</b></div>
          <div class="col-md-3">Dibayar<br><b>{{ fmt(detail.total.paid) }}</b></div>
        </div>

        <ul class="nav nav-tabs mb-3">
          <li class="nav-item" v-for="(tab, i) in tabs" :key="'tab'+i">
            <a :class="'nav-link text-sm '+(activeTab == tab.key ? 'active' : '')" href="javascript:void(0)" @click="activeTab = tab.key">{{ tab.label }}</a>
          </li>
        </ul>

        <!-- rincian anggaran -->
        <div v-if="activeTab == 'lines'">
          <p class="text-xs" v-if="!detail.evaluation || detail.evaluation.lines.length == 0">Belum ada rincian anggaran per kategori / supplier.</p>
          <table class="table table-sm align-items-center" v-else>
            <thead><tr>
              <th class="text-xxs text-secondary">Jenis</th><th class="text-xxs text-secondary">Nama</th><th class="text-xxs text-secondary text-end">Anggaran</th><th class="text-xxs text-secondary text-end">Realisasi PO</th><th class="text-xxs text-secondary" style="min-width: 140px;">Pemakaian</th>
            </tr></thead>
            <tbody>
              <tr v-for="(line, i) in detail.evaluation.lines" :key="'l'+i">
                <td class="text-xs">{{ line.line_type == 'category' ? 'Kategori' : 'Supplier' }}</td>
                <td class="text-xs">{{ line.name }}</td>
                <td class="text-xs text-end">{{ fmt(line.budget) }}</td>
                <td class="text-xs text-end">{{ fmt(line.committed) }}</td>
                <td class="text-xs">
                  <span class="font-weight-bold">{{ line.percent }}%</span>
                  <div class="progress"><div :class="'progress-bar '+barColor(line.percent, line.level)" :style="'width: '+Math.min(100, line.percent)+'%'"></div></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- realisasi per kategori / supplier / item -->
        <div v-else class="table-responsive" style="max-height: 420px; overflow-y: auto;">
          <table class="table table-sm align-items-center">
            <thead><tr>
              <th class="text-xxs text-secondary">{{ activeTab == 'item' ? 'Item' : (activeTab == 'supplier' ? 'Supplier' : 'Kategori') }}</th>
              <th class="text-xxs text-secondary" v-if="activeTab == 'item'">Kategori</th>
              <th class="text-xxs text-secondary text-center" v-if="activeTab == 'item'">Qty</th>
              <th class="text-xxs text-secondary text-end">Realisasi PO</th>
              <th class="text-xxs text-secondary text-end">Diterima</th>
              <th class="text-xxs text-secondary text-end">Dibayar</th>
              <th class="text-xxs text-secondary text-end">% dari Total</th>
            </tr></thead>
            <tbody>
              <tr v-for="(row, i) in breakdown" :key="'b'+i">
                <td class="text-xs">{{ activeTab == 'item' ? row.code+' - ' : '' }}{{ row.name }}</td>
                <td class="text-xs" v-if="activeTab == 'item'">{{ row.category_name }}</td>
                <td class="text-xs text-center" v-if="activeTab == 'item'">{{ row.qty }} {{ row.unit }}</td>
                <td class="text-xs text-end">{{ fmt(row.committed) }}</td>
                <td class="text-xs text-end">{{ fmt(row.received) }}</td>
                <td class="text-xs text-end">{{ fmt(row.paid) }}</td>
                <td class="text-xs text-end">{{ detail.total.committed > 0 ? (row.committed / detail.total.committed * 100).toFixed(1) : 0 }}%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL FORM ANGGARAN ======= -->
  <div class="container">
    <vue-final-modal v-model="formBudget.show" classes="modal-container" content-class="modal-content-width" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left">
          <span class="modal__title">{{ formBudget.title }}</span>
        </div>
        <div class="col-1 float-right">
          <i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formBudget.show = false"></i>
        </div>
      </div><hr>
      <div class="modal__content container">
        <div class="row">
          <div class="col-md-4">
            <label class="form-control-label">Total Anggaran (IDR) <span style="color: red;">*</span></label>
            <input type="number" step="0.01" min="0" class="form-control" v-model="form.total_budget">
            <small class="text-xs">Realisasi saat ini: {{ fmt(detail.total.committed) }}</small>
          </div>
          <div class="col-md-2">
            <label class="form-control-label">Warning (%) <span style="color: red;">*</span></label>
            <input type="number" min="1" max="100" class="form-control" v-model="form.warning_percent">
          </div>
          <div class="col-md-6">
            <label class="form-control-label">Email Notifikasi Over Budget</label>
            <input type="text" class="form-control" placeholder="pisahkan dengan koma, mis. pm@tef.co.id, finance@tef.co.id" v-model="form.notify_emails">
          </div>
        </div>
        <label class="form-control-label mt-2">Catatan</label>
        <input type="text" class="form-control" v-model="form.note">

        <h6 class="text-sm mt-4 mb-1">Rincian Anggaran</h6>
        <p class="text-xs mb-2">
          Kategori teralokasi: <b>{{ fmt(categoryAllocated) }}</b> dari {{ fmt(form.total_budget) }}
          <span class="text-danger" v-if="categoryAllocated > Number(form.total_budget || 0)">(melebihi total anggaran)</span>
        </p>
        <table class="table table-sm align-items-center">
          <thead><tr>
            <th class="text-xxs text-secondary" style="width: 120px;">Jenis</th><th class="text-xxs text-secondary">Kategori / Supplier</th><th class="text-xxs text-secondary" style="width: 200px;">Anggaran (IDR)</th><th class="text-xxs text-secondary text-end">Realisasi Saat Ini</th><th></th>
          </tr></thead>
          <tbody>
            <tr v-for="(line, i) in form.lines" :key="'f'+i">
              <td class="text-xs">{{ line.line_type == 'category' ? 'Kategori' : 'Limit Supplier' }}</td>
              <td>
                <select class="form-select form-select-sm" v-model="line.ref_code" v-if="line.line_type == 'category'">
                  <option v-for="(c, k) in detail.categories" :key="'cat'+k" :value="c.category_code">{{ c.category_code }} - {{ c.category_name }}</option>
                </select>
                <select class="form-select form-select-sm" v-model="line.ref_code" v-else>
                  <option v-for="(v, k) in detail.vendors" :key="'ven'+k" :value="v.vendor_code">{{ v.company_name }} ({{ v.vendor_code }})</option>
                </select>
              </td>
              <td><input type="number" step="0.01" min="0" class="form-control form-control-sm" v-model="line.amount"></td>
              <td class="text-xs text-end">{{ fmt(currentRealization(line)) }}</td>
              <td><i class="fa fa-times text-danger" style="cursor: pointer;" title="Hapus rincian ini" @click="form.lines.splice(i, 1)"></i></td>
            </tr>
          </tbody>
        </table>
        <argon-button variant="outline" color="secondary" size="sm" style="margin-right: 10px;" @click="form.lines.push({line_type: 'category', ref_code: '', amount: ''})">+ Kategori</argon-button>
        <argon-button variant="outline" color="secondary" size="sm" @click="form.lines.push({line_type: 'supplier', ref_code: '', amount: ''})">+ Limit Supplier</argon-button>
      </div>
      <div class="row float-right mt-4">
        <div class="col-6"></div>
        <div class="col-2" style="margin-right: 20px;">
          <argon-button variant="gradient" color="secondary" size="sm" width="1" @click="formBudget.show = false">Close</argon-button>
        </div>
        <div class="col-1">
          <argon-button variant="gradient" color="success" size="sm" width="1" @click="saveBudget()" :disabled="onLoading">
            <span v-if="onLoading"><i class="fa fa-spinner fa-spin"></i> Please Wait...</span>
            <span v-else>Save</span>
          </argon-button>
        </div>
      </div>
    </vue-final-modal>
  </div>

  <!-- =======  MODAL KURS ======= -->
  <div class="container">
    <vue-final-modal v-model="formRates.show" classes="modal-container" content-class="modal-content" :z-index="10000">
      <div class="row">
        <div class="col-11 float-left"><span class="modal__title">Kurs Mata Uang ke IDR</span></div>
        <div class="col-1 float-right"><i style="cursor: pointer;" class="fa fa-times" aria-hidden="true" @click="formRates.show = false"></i></div>
      </div><hr>
      <div class="modal__content container">
        <p class="text-xs">Dipakai untuk mengonversi PO non-IDR ke IDR di Budget Control.</p>
        <div class="row mb-2" v-for="(rate, i) in rates" :key="'r'+i">
          <div class="col-3 pt-2 text-sm font-weight-bold">1 {{ rate.currency }} =</div>
          <div class="col-5"><input type="number" step="0.0001" min="0" class="form-control" placeholder="IDR" v-model="rate.rate_to_idr"></div>
          <div class="col-4">
            <argon-button variant="gradient" color="success" size="sm" @click="saveRate(rate)">Simpan</argon-button>
          </div>
          <div class="col-12"><small class="text-xxs" v-if="rate.updated_by">Update terakhir: {{ rate.updated_by }}, {{ moment(rate.updated_at).locale('id').format('LLL') }}</small></div>
        </div>
      </div>
    </vue-final-modal>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import { VueFinalModal } from 'vue-final-modal'
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
var moment = require('moment');
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccBudgetControl",
  components: {
    ArgonButton,
    VueFinalModal,
  },
  data() {
    return {
      moment: moment,
      table: { data: [] },
      counts: { budgeted: 0, ok: 0, warning: 0, over: 0 },
      missingRates: [],
      search: { search: '', status: '' },
      formDetail: { show: false },
      formBudget: { show: false, title: '' },
      formRates: { show: false },
      detail: { wo: null, budget: null, evaluation: null, total: {}, byCategory: [], bySupplier: [], byItem: [], categories: [], vendors: [] },
      activeTab: 'lines',
      tabs: [
        { key: 'lines', label: 'Rincian Anggaran' },
        { key: 'category', label: 'Per Kategori' },
        { key: 'supplier', label: 'Per Supplier' },
        { key: 'item', label: 'Per Item' },
      ],
      form: { lines: [] },
      rates: [],
      onLoading: false,
    };
  },
  computed: {
    cards() {
      return [
        { label: 'Proyek Beranggaran', value: this.counts.budgeted, color: '', filter: '' },
        { label: 'Aman', value: this.counts.ok, color: 'text-success', filter: 'ok' },
        { label: 'Warning', value: this.counts.warning, color: 'text-warning', filter: 'warning' },
        { label: 'Over Budget', value: this.counts.over, color: 'text-danger', filter: 'over' },
      ];
    },
    breakdown() {
      if (this.activeTab == 'category') return this.detail.byCategory;
      if (this.activeTab == 'supplier') return this.detail.bySupplier;
      return this.detail.byItem;
    },
    categoryAllocated() {
      return this.form.lines.filter(l => l.line_type == 'category').reduce((sum, l) => sum + Number(l.amount || 0), 0);
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    fmt(value) {
      return 'IDR '+Number(value || 0).toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    },
    barColor(percent, level) {
      if (level == 'over' || percent > 100) return 'bg-gradient-danger';
      if (level == 'warning') return 'bg-gradient-warning';
      return 'bg-gradient-success';
    },
    get() {
      let context = this;
      Api(context, accounting.budget({ search: context.search.search, status: context.search.status })).onSuccess(function(response) {
          context.table.data   = response.data.data.data;
          context.counts       = response.data.data.counts;
          context.missingRates = response.data.data.missingRates;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    filterStatus(status) {
      this.search.status = status;
      this.get();
    },
    loadDetail(woCode, callback) {
      let context = this;
      Api(context, accounting.showBudget(woCode)).onSuccess(function(response) {
          context.detail = response.data.data;
          callback();
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    openDetail(woCode) {
      let context = this;
      context.loadDetail(woCode, function() {
        context.activeTab = (context.detail.evaluation && context.detail.evaluation.lines.length > 0) ? 'lines' : 'category';
        context.formDetail.show = true;
      });
    },
    openForm(woCode) {
      let context = this;
      context.loadDetail(woCode, function() {
        let budget = context.detail.budget;
        context.form = {
          wo_code:         woCode,
          total_budget:    budget ? budget.total_budget : '',
          warning_percent: budget ? budget.warning_percent : 80,
          notify_emails:   budget ? (budget.notify_emails || '') : '',
          note:            budget ? (budget.note || '') : '',
          lines:           (context.detail.budgetLines || []).map(l => ({ line_type: l.line_type, ref_code: l.ref_code, amount: l.amount })),
        };
        context.formBudget.title = (budget ? 'Ubah' : 'Buat')+' Anggaran '+woCode+(context.detail.wo ? ' - '+context.detail.wo.project : '');
        context.formBudget.show  = true;
      });
    },
    currentRealization(line) {
      let source = (line.line_type == 'category') ? this.detail.byCategory : this.detail.bySupplier;
      let found  = source.find(s => s.code == line.ref_code);
      return found ? found.committed : 0;
    },
    saveBudget() {
      let context = this;
      if (context.form.total_budget === '' || Number(context.form.total_budget) < 0) {
        return alert('Total Anggaran wajib diisi');
      }
      if (context.form.lines.some(l => !l.ref_code || l.amount === '' || Number(l.amount) < 0)) {
        return alert('Lengkapi kategori/supplier dan nilai di setiap rincian anggaran');
      }
      context.onLoading = true;
      Api(context, accounting.saveBudget(context.form)).onSuccess(function(response) {
          context.formBudget.show = false;
          context.notify('Anggaran Berhasil Disimpan', 'success')
          context.showAlerts(response.data.data.alerts);
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Anggaran Gagal Disimpan', 'error')
      }).onFinish(function() {
          context.onLoading = false;
      })
      .call();
    },
    showAlerts(alerts) {
      (alerts || []).forEach(a => {
        this.notify((a.level == 'over' ? 'OVER BUDGET: ' : 'Warning: ')+a.scope+' sudah '+a.percent+'%', a.level == 'over' ? 'error' : 'warning');
      });
    },
    removeBudget(row) {
      if (!confirm('Hapus anggaran '+row.wo_code+'? Rincian anggarannya ikut terhapus.')) {
        return;
      }
      let context = this;
      Api(context, accounting.deleteBudget(row.budget_id)).onSuccess(function() {
          context.notify('Anggaran Dihapus', 'success')
          context.get();
      }).onError(function() {
          context.notify('Gagal Menghapus Anggaran', 'error')
      })
      .call();
    },
    openRates() {
      let context = this;
      Api(context, accounting.currencyRates()).onSuccess(function(response) {
          context.rates          = response.data.data;
          context.formRates.show = true;
      }).call();
    },
    saveRate(rate) {
      let context = this;
      if (!(Number(rate.rate_to_idr) > 0)) {
        return alert('Kurs harus lebih dari 0');
      }
      Api(context, accounting.saveCurrencyRate({ currency: rate.currency, rate_to_idr: rate.rate_to_idr })).onSuccess(function() {
          context.notify('Kurs '+rate.currency+' Disimpan', 'success')
          context.openRates();
          context.get();
      }).onError(function() {
          context.notify('Kurs Gagal Disimpan', 'error')
      })
      .call();
    },
    notify(message, type) {
      let options = { position: toast.POSITION.BOTTOM_RIGHT, autoClose: type == 'success' ? 2000 : 6000 };
      if (type == 'success') {
        toast.success(message, options);
      } else if (type == 'warning') {
        toast.warning(message, options);
      } else {
        toast.error(message, options);
      }
    },
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
}
::v-deep .modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 500px;
  margin-top: auto;
  margin-bottom: auto;
}
::v-deep .modal-content-width {
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 1000px;
  max-height: 90vh;
  overflow-y: auto;
  margin-top: auto;
  margin-bottom: auto;
}
.modal__title {
  font-size: 1rem;
  font-weight: 600;
}
.scroll {
  overflow: auto;
  height: 600px;
}
.scroll thead th {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: #F0F8FF;
}
.progress {
  height: 6px;
}
</style>
